import * as actionTypes from "./constants";
import { saveState } from "../containers/localStorage";
import * as phases from "../utils/helpers/phases";
import { SYNC_HOTEL_SUCCESS } from "../synchronization/constants";
import { removeFromArray } from "../utils/helpers/immutable";

const hotelInitialState = {
  selected: undefined,
  data: [],
  phase: phases.INIT
};
const hotel = (state = hotelInitialState, action) => {
  switch (action.type) {
    case actionTypes.REMOVE_HOTEL_REQUEST:
    case actionTypes.CREATE_HOTEL_REQUEST:
    case actionTypes.GET_HOTEL_REQUEST:
      return {
        ...state,
        phase: phases.LOADING
      };
    case actionTypes.CREATE_HOTEL_SUCCESS:
      saveState("hotels", state.data.concat(action.hotel));
      return {
        ...state,
        phase: phases.LOADED,
        data: state.data.concat(action.hotel),
        selected: action.hotel.hotelId
      };

    case actionTypes.REMOVE_HOTEL_SUCCESS:
      const newHotels = removeFromArray(
        state.data.findIndex(hotel => hotel.hotelId === action.hotel.hotelId),
        state.data
      );
      saveState("hotels", newHotels);
      return {
        ...state,
        phase: phases.LOADED,
        data: newHotels
      };

    case actionTypes.GET_HOTEL_SUCCESS:
    case SYNC_HOTEL_SUCCESS:
      saveState("hotels", action.hotels);
      return {
        ...state,
        phase: phases.LOADED,
        data: action.hotels,
        selected:
          state.selected || action.hotels.length > 0
            ? action.hotels[0].hotelId
            : state.selected
      };
    case actionTypes.REMOVE_HOTEL_REJECT:
    case actionTypes.CREATE_HOTEL_REJECT:
    case actionTypes.GET_HOTEL_REJECT:
      return {
        ...state,
        phase: phases.ERROR
      };

    case actionTypes.CHANGE_HOTEL:
      saveState("selectedHotel", action.selected);
      return {
        ...state,
        selected: action.selected
      };

    default:
      return state;
  }
};

export default hotel;



// WEBPACK FOOTER //
// ./src/hotels/reducer.js